<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="tocf"><a href="#/xhtml/05_Illustrations"><em class="italic">List of Illustrations</em></a></h2>
<h2 class="tocf2"><a href="#/xhtml/06_Acknowledgements"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="toc"><a href="#/xhtml/07_Chapter01"><span class="tochang">1.</span> From Wales to Cuba, 1797–1961</a></h2>
<h2 class="toc"><a href="#/xhtml/08_Chapter02"><span class="tochang">2.</span> Fishguard, 1797: Militia, Fencibles, and Volunteers</a></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample"><span class="tochang">3.</span> The War of 1812: War, Society and Politics – Militias in the United States and Canada, 1812–15</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample"><span class="tochang">4.</span> The Rifle Volunteers: The ‘Wonder of the Age’, the Victorian Amateur Soldier</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample"><span class="tochang">5.</span> The Spanish-American War, Cuba 1898</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample"><span class="tochang">6.</span> Spain, 1936–39: Ideological War and Murder; Militias in the Spanish Civil War</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample"><span class="tochang">7.</span> Cuba 1960–61: Defending the Revolution – From the Escambray Mountains to the Bay of Pigs</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample"><span class="tochang">8.</span> Amateurs in the Age of the Professional</span></h2>
<h2 class="tocf1"><span href="#/xhtml/15_Notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></h2>
<h2 class="tocf"><span href="#/xhtml/16_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?53349e26